module.exports = __webpack_public_path__ + "static/SIFONN_PRO-a8ee4641e93ad696e616477beec5c85d.woff";